<template>
    <div>
        <section class="xlrclh">
            <img class="top-img" src="./../assets/imgs/xllh/rcgysq.png" alt="" />
            <div class="technological-process">
                <div class="zcjj">
                    <img class="top" style="height: 1.12rem" src="./../assets/imgs/xllh/rcgyysq_zcjj.png" alt="" />
                    <div class="content">
                        <div class="des">
                            大力实施人才安居工程，构建起“租售补”并举的服务体系，满足人才多元化住房需求，面向已取得成都市人才安居资格的人才租售人才公寓，推动实现各类人才住有所居、住有宜居。
                        </div>
                    </div>
                </div>
                <div class="rhtj mar-t2">
                    <img class="top" src="./../assets/imgs/xllh/rcgysq_sqdx.png" alt="" />

                    <div class="content" style="padding-top: 0.3rem;">
                        <div class="des" style="padding: 0.3rem;">
                            符合《成都市人才分类目录》条件的A、B、C、D、E、F类人才。
                        </div>
                        <!-- <div class="des mar-t3">
                            <img src="./../assets/imgs/xllh/alrc.png" alt="" />
                            主要包括：诺贝尔奖、图灵奖、菲尔兹奖；国家最高科学技术奖获得者；中国科学院院士；中国工程院院士；中国社会科学院学部委员、荣誉学部委员；国家高层次人才特殊支持计划杰出人才人选；国家海外高层次人才引进计划顶尖人才与创新团队人选；相当于上述层次的顶尖人才。
                        </div>
                        <div class="des mar-t2">
                            <img src="./../assets/imgs/xllh/blrc.png" alt="" />
                            主要包括：国家有突出贡献的中青年专家；中国青年科技奖获得者；享受国务院政府特殊津贴的专家；国家高层次人才特殊支持计划中除杰出人才之外的人选、国家海外高层次人才引进计划除顶尖人才与创新团队之外的人选；百千万人才工程国家级人选；“长江学者奖励计划”教授；国家自然科学奖、国家技术发明奖、国家科学技术进步奖一等奖及以上获得者或项目主要完成人（前3名完成人）；中国工艺美术大师；国家级非物质文化遗产传承人；中华技能大奖获得者；省科学技术杰出贡献奖获得者；相当于上述层次的领军人才。
                        </div>
                        <div class="des mar-t2">
                            <img src="./../assets/imgs/xllh/clrc.png" alt="" />
                            主要包括：省青年科技奖获得者；省有突出贡献的优秀专家；天府峨眉计划人选；天府青城计划人选；四川杰出人才奖获得者；“蓉漂计划”人选；成都市有突出贡献的优秀专家；享受成都市政府特殊津贴人员；国家自然科学奖、国家技术发明奖、国家科学技术进步奖二等奖获得者或项目主要完成人，省自然科学奖、技术发明奖、科学技术进步类一等奖及以上获得者或项目第一完成人；省社会科学优秀成果奖一等奖及以上获得者或项目第一完成人；四川省学术与技术带头人；省级工艺美术大师；全国技术能手；国家级技能大师工作室领衔人；省级非物质文化遗产传承人；“成都市产业建圈强链人才计划”入选者；相当于上述层次的领军人才。
                        </div>
                        <div class="des mar-t2">
                            <img src="./../assets/imgs/xllh/dlrc.png" alt="" />
                            主要包括：具有正高级专业技术职务任职资格的专业技术人才；取得研究生及以上学历且获得相应学位的国内外高校毕业生（国〈境〉外高校学历学位须通过教育部留学服务中心认证）；省或市级技能大师工作室领衔人；市级工艺美术大师；具有高级社会工作师职业资格证书；相当于上述层次的人才。
                        </div> -->
                    </div>
                </div>
                <div class="sxcl">
                    <img class="top" src="./../assets/imgs/xllh/rcgysq_sqtj.png" alt="" />
                    <div class="content">
                        <!-- <div class="title">
                            <span class="hollow-cricle"></span>
                            根据《成都市人才公寓租售管理办法》，
                            申请租购人才公寓还须同时符合以下条件：
                        </div> -->
                        <div class="describe">
                            <div class="des" style="padding: 0.3rem;">
                                在四川天府新区、成都高新区、锦江区、青羊区、金牛区、武侯区、成华区、龙泉驿区、青白江区、新都区、温江区、双流区、郫都区工作的，须在本市无自有产权住房且未享受过其他住房优惠政策，在成都东部新区、新津区、简阳市、都江堰市、彭州市、邛崃市、崇州市、金堂县、大邑县、蒲江县工作的，须在用人单位注册地所在县市无自有产权住房且未在当地享受过其他住房优惠政策。
                            </div>
                            <!-- <div style="display: flex" class="describe-item mar-t3">
                                <div class="num">1</div>
                                <div class="" style="line-height: 0.44rem">
                                    与本市用人单位签订劳动合同并缴纳社会保险（劳动合同签订单位与社会保险缴纳单位须一致）。
                                </div>
                            </div>
                            <div style="display: flex" class="describe-item mar-t3">
                                <div class="num">2</div>
                                <div class="" style="line-height: 0.44rem">
                                    在四川天府新区、成都高新区、锦江区、青羊区、金牛区、武侯区、成华区、龙泉驿区、青白江区、新都区、温江区、双流区、郫都区工作的，须在本市无自有产权住房且未享受过其他住房优惠政策。
                                    <br />
                                    在成都东部新区、新津区、简阳市、都江堰市、彭州市、邛崃市、崇州市、金堂县、大邑县、蒲江县工作的，须在用人单位注册地所在县市无自有产权住房且未在当地享受过其他住房优惠政策。
                                </div>
                            </div>
                            <div class="url-content describe-item mar-t3">
                                可登录以下网址具体查询《成都市人才公寓租售管理办法》：
                                <div>
                                    <span
                                        style="
                                                                                word-break: break-all;
                                                                                color: #1355ff;
                                                                                font-size: 0.26rem;
                                                                            ">http://cdzj.chengdu.gov.cn/cdzj/c150804/2021-12/21/content_f6a0e16b08c24af4a94d46782ad38cfc.shtml</span>
                                </div>
                                (复制到手机浏览器打开)
                            </div> -->
                        </div>
                    </div>
                </div>
                <div class="zcnr">
                    <img class="top" src="./../assets/imgs/xllh/rcgysq_zcnr.png" alt="" />
                    <div class="content">
                        <div class="des">
                            人才通过优惠出售方式优先、优惠购买人才公寓，优惠政策面积部分可享受购房款15%的政策性优惠。
                        </div>
                        <p class="des mar-t2">
                            其中:A类：人才租购人才公寓可享受优惠政策面积不超过200平方米;
                            <br />
                            B类：人才租购人才公寓可享受优惠政策面积不超过120平方米;<br />
                            C类：人才租购人才公寓可享受优惠政策面积不超过90平方米;<br />
                            D类：人才租购人才公寓可享受优惠政策面积不超过70平方米;<br /> E类：人才租购人才公寓可享受优惠政策面积不超过60平方米;<br />
                            F类：人才享受同等条件优先购买资格但不享受优惠。
                            A、B、C类人才可不受工作单位注册地限制跨区域优惠购买人才公寓。
                        </p>
                        <!-- <div class="rcajewm">
                            <img src="./../assets/imgs/xllh/rcgysq_rcajewm_code.png" alt="" />
                        </div> -->
                    </div>
                </div>
                <div class="bllc">
                    <img class="top" src="./../assets/imgs/xllh/bllc.png" alt="" />
                    <div class="content">
                        <!-- <div class="title">
                            <span class="hollow-cricle"></span>人才可自行登录成都人才安居服务网，
                            按照提示在线完善个人信息，进行人才 安居资格申请。
                        </div> -->
                        <div class="bllc-text">
                            符合条件的人才可自行登录“成都人才安居服务网”进行申报。
                        </div>
                    </div>
                </div>
                <!-- <div class="gmlc">
                    <img class="top" src="./../assets/imgs/xllh/more.png" alt="" />
                    <div class="content">
                        <div class="title">
                            <span class="hollow-cricle"></span>
                            取得安居资格后如何购买人才公寓
                        </div>
                        <div class="des mar-t3">
                            <div class="line-item">
                                <div class="line"></div>
                                <div class="line-top">
                                    <div class="line-num">1</div>
                                    <div class="line-title">
                                        登录成都人才安居服务网;
                                    </div>
                                </div>
                                <div class="line-content">
                                    <span style="
                                                                            color: #1355ff;
                                                                            display: inline-block;
                                                                            font-size: 0.26rem;
                                                                        ">
                                        http://cdzj.chengdu.gov.cn/cdzj/rcaj/RCAJ.shtml
                                    </span>
                                    (复制到手机浏览器打开)
                                </div>

                            </div>
                            <div class="line-item">
                                <div class="line"></div>
                                <div class="line-top">
                                    <div class="line-num">2</div>
                                    <div class="line-title">
                                        点击“租购报名”（A、B、C类人才可不受工作单位注册地限制跨区域登记）;
                                    </div>
                                </div>
                                <div class="line-content" style="color: #1355ff"></div>
                            </div>
                            <div class="line-item">
                                <div class="line"></div>
                                <div class="line-top">
                                    <div class="line-num">3</div>
                                    <div class="line-title">
                                        按照提示，完成租购登记;
                                    </div>
                                </div>
                                <div class="line-content" style="color: #1355ff"></div>
                            </div>
                            <div class="line-item">
                                <div class="line-top">
                                    <div class="line-num">4</div>
                                    <div class="line-title">
                                        现场选房签约（选房顺序将按照人才类别由高到低依次选房，相同类别的人才以取得安居资格的时间先后顺序选房）。
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->
                <div class="contact">
                    <img class="top" src="./../assets/imgs/rcgysq/title5.png" alt="" />
                    <div class="content">全年。</div>
                </div>
                <div class="contact">
                    <img class="top" src="./../assets/imgs/rcgysq/title6.png" alt="" />
                    <div class="content">
                        <div class="number">
                            <span class="label">政策咨询电话：</span>
                            <div>
                                <a href="tel:028-61889280">028-61889280</a>
                            </div>
                        </div>
                        <div class="unit">
                            <span class="label">责任单位：</span>
                            成都市住房和城乡建设局住房保障处
                        </div>
                    </div>
                </div>
                <div class="sqsj" style="padding: 0.3rem;">
                    <img src="./../assets/imgs/xllh/rcgysq_sqsj_code.png" alt="" style="width:100%" />
                </div>
                <!-- <div class="zrdw">责任单位：成都市住房和城乡建设局住房保障处</div>
                                                                            <div class="zrdw">
                                                                                咨询电话：<a href="tel:028-61889280">028-61889280</a>
                                                                            </div> -->
                <!-- <div class="phone-list">
                    <img class="phone-list-title" src="./../assets/imgs/xllh/rcgy_gqxlxfs.png" alt="" />
                    <div class="content-list">
                        <div class="content-item">
                            <div class="area">
                                <img class="area-img" src="./../assets/imgs/xllh/rcgy_qx.png" alt="" />
                            </div>
                            <div class="lxfs">
                                <img class="lxfs-img" style="width: 1.55rem; height: 0.43rem"
                                    src="./../assets/imgs/xllh/rcgy_lxfs.png" alt="" />
                            </div>
                        </div>
                        <div class="content-item" v-for="(phone, p_index) in phoneList" :key="p_index">
                            <div class="area">{{ phone.area }}</div>
                            <div class="lxfs" style="font-weight: normal; color: #1355ff">
                                <span @click="callPhone(phone.phone)">{{
                                    phone.phone
                                }}</span>
                            </div>
                        </div>
                    </div>
                </div> -->
                <!-- <bottom
                                                                                    phone="028-61889280"
                                                                                    unit="成都市住房和城乡建设局住房保障处"
                                                                                ></bottom> -->
            </div>
        </section>
        <!-- <call phone="028-61889280" site="https://zw.cdzjryb.com/talentsPlaceOuter/beforeApply/goApply" goIndex="2"></call> -->
        <call phone="028-61889280" site="https://zw.cdzjryb.com/talentsPlaceOuter/beforeApply/goApply"></call>
    </div>
</template>

<script>
// import bottom from "../components/bottom.vue";
import call from "../components/call.vue";

export default {
    data() {
        return {
            phoneList: [
                {
                    area: "四川天府新区",
                    phone: "028-68773091 ",
                    // phone2: "028-68772540",
                },
                {
                    area: "成都东部新区",
                    phone: "028-86360182",
                    // phone2: "028-86360118",
                },
                {
                    area: "成都高新区",
                    phone: "028-85327961",
                    // phone2: "028-85155164",
                },
                {
                    area: "锦江区",
                    phone: "028-84531499",
                    // phone2: "028-86511559",
                },
                {
                    area: "青羊区",
                    phone: "028-87701527",
                    // phone2: "028-86269217",
                },
                {
                    area: "金牛区",
                    phone: "028-84757803",
                    // phone2: "028-87705569",
                },
                {
                    area: "武侯区",
                    phone: "028-85440059",
                    // phone2: "028-85073287",
                },
                {
                    area: "成华区",
                    phone: "028-84399067",
                    // phone2: "028-84310100",
                },
                {
                    area: "龙泉驿区",
                    phone: "028-84857075",
                    // phone2: "028-84851306",
                },
                {
                    area: "青白江区",
                    phone: "028-83668168",
                    // phone2: "028-83666750",
                },
                {
                    area: "新都区",
                    phone: "028-89396620",
                    // phone2: "028-83977025",
                },
                {
                    area: "温江区",
                    phone: "028-82706623",
                    // phone2: "028-86299565",
                },
                {
                    area: "双流区",
                    phone: "028-85805996",
                    // phone2: "028-85811323",
                },
                {
                    area: "郫都区",
                    phone: "028-87862150",
                    // phone2: "028-87862090",
                },
                {
                    area: "新津区",
                    phone: "028-82518637",
                    // phone2: "028-82479907",
                },
                {
                    area: "简阳市",
                    phone: "028-27228483",
                    // phone2: "028-27028373",
                },
                {
                    area: "都江堰市",
                    phone: "028-87121893",
                    // phone2: "028-87110731",
                },
                {
                    area: "彭州市",
                    phone: "028-83707516",
                    // phone2: "028-83881823",
                },
                {
                    area: "邛崃市",
                    phone: "028-88763155",
                    // phone2: "028-88767320",
                },
                {
                    area: "崇州市",
                    phone: "028-82180719",
                    // phone2: "028-82203533",
                },
                {
                    area: "金堂县",
                    phone: "028-84935006",
                    // phone2: "028-84997012",
                },
                {
                    area: "大邑县",
                    phone: "028-88290117",
                    // phone2: "028-88211208",
                },
                {
                    area: "蒲江县",
                    phone: "028-88536736",
                    // phone2: "028-88555682",
                },
            ],
        };
    },
    components: {
        // bottom,
        call,
    },

    mounted() { },

    methods: {
        callPhone(phone) {
            window.location.href = "tel://" + phone;
        },
    },
};
</script>
<style lang="scss" scoped>
@import "@/assets/public.scss";

.xlrclh {
    background-color: $base-back;
    padding-bottom: 0.1rem;

    .top-img {
        width: 7.26rem;
        height: 5.6rem;
    }

    .technological-process {
        transform: translateY(-1.9rem);

        .zcjj {
            .top {
                width: 6.68rem;
                height: 2.12rem;
            }

            .content {
                width: 6.68rem;
                background: #ffffff;
                margin: -0.45rem auto 0;
                padding: 0.1rem 0.33rem 0.64rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                line-height: 0.44rem;


                .title {
                    font-size: 0.34rem;
                    font-weight: bold;
                    color: #333333;
                    text-align: left;
                    line-height: 0.5rem;
                }

                .des {
                    font-size: 0.26rem;
                    color: #4e4e4e;
                    line-height: 0.44rem;
                    text-align: left;
                    margin-top: 0.16rem;
                }
            }
        }

        .rhtj {
            position: relative;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.45rem auto 0;
                padding: 0 0.33rem 0.64rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;

                .title {
                    font-size: 0.36rem;
                    font-weight: bold;
                    color: #333333;
                    text-align: left;
                    line-height: 0.5rem;
                }

                .des {
                    font-size: 0.26rem;
                    color: #4e4e4e;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.7rem 0.23rem 0.3rem;
                    text-align: left;
                    line-height: 0.44rem;
                    position: relative;

                    img {
                        position: absolute;
                        width: 1.74rem;
                        height: 0.6rem;
                        top: 0;
                        left: 0;
                    }
                }
            }
        }

        .zcnr {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.45rem auto 0;
                padding: 0 0.33rem 0.64rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                padding-top: 0.28rem;
                font-size: 0.26rem;
                // font-weight: 500;
                text-align: left;
                color: #4e4e4e;

                .des {
                    font-size: 0.26rem;
                    // font-weight: 500;
                    color: #4e4e4e;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.3rem 0.23rem 0.3rem;
                    text-align: left;
                    line-height: 0.44rem;
                    position: relative;
                }

                .rcajewm {
                    margin-top: 0.36rem;
                    width: 6.15rem;
                    height: 1.52rem;
                    background-image: url("./../assets/imgs/xllh/rcgysq_rcajewm.png");
                    background-size: 100% 100%;
                    background-repeat: no-repeat;

                    img {
                        width: 1.31rem;
                        height: 1.31rem;
                    }
                }
            }
        }

        .sxcl {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.45rem auto 0;
                padding: 0 0.33rem 0.64rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                padding-top: 0.28rem;
                font-size: 0.26rem;
                // font-weight: 500;
                text-align: left;
                color: #4e4e4e;
                line-height: 0.44rem;

                .title {
                    font-size: 0.36rem;
                    font-weight: bold;
                    color: #333333;
                    text-align: left;
                    line-height: 0.5rem;
                }

                .describe {
                    background: linear-gradient(180deg,
                            #ffffff 0%,
                            rgba(255, 255, 255, 0) 100%);
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    opacity: 1;
                    padding: 0.33rem 0.33rem 0 0.15rem;
                    // line-height: 0.44rem;

                    .num {
                        min-width: 0.39rem;
                        height: 0.39rem;
                        background: #739bfe;
                        color: #ffffff;
                        display: inline-flex;
                        border-radius: 50%;
                        justify-content: center;
                        align-items: center;
                        margin-right: 0.14rem;
                    }
                }

                .url-content {
                    padding: 0.33rem 0.33rem 0 0.5rem;
                    line-height: 0.44rem;
                }
            }
        }

        .bllc {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.45rem auto 0;
                padding: 0 0.33rem 0.64rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;

                .title {
                    font-size: 0.36rem;
                    font-weight: bold;
                    color: #333333;
                    text-align: left;
                    line-height: 0.5rem;
                }

                .bllc-text {
                    padding: 0.25rem;
                    font-size: 0.26rem;
                    // //font-family:: PingFang SC-Medium, PingFang SC;
                    // font-weight: 500;
                    color: #4e4e4e;
                    box-sizing: border-box;
                    background: #fff;
                    border-radius: 10px;
                    margin-top: 0.2rem;
                    line-height: 0.44rem;

                    text-align: left;
                }
            }
        }

        .gmlc {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.45rem auto 0;
                padding: 0 0.33rem 0.64rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;

                .title {
                    font-size: 0.36rem;
                    font-weight: bold;
                    color: #333333;
                    text-align: left;
                    line-height: 0.5rem;
                }

                .des {
                    color: #4e4e4e;
                    text-align: left;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.3rem 0.23rem;

                    .line-item {
                        font-size: 0.26rem;
                        position: relative;
                        z-index: 3;

                        .line {
                            position: absolute;
                            width: 0.02rem;
                            height: 100%;
                            border-left: 0.02rem dashed #739bfe;
                            left: 0.2rem;
                            z-index: 0;
                            //   background-color: #739bfe;
                        }

                        .line-top {
                            display: flex;
                            line-height: 0.44rem;

                            .line-num {
                                min-width: 0.39rem;
                                height: 0.39rem;
                                line-height: 0.39rem;
                                background: #739bfe;
                                color: #ffffff;
                                display: inline-flex;
                                border-radius: 50%;
                                justify-content: center;
                                align-items: center;
                                margin-right: 0.14rem;
                                position: relative;
                                z-index: 3;
                            }
                        }

                        .line-content {
                            //   border-left: 0.02rem dashed #739bfe;
                            padding-bottom: 0.32rem;
                            margin-left: 0.2rem;
                            padding-left: 0.32rem;
                            padding-top: 0.15rem;
                            word-break: break-all;
                            line-height: 0.44rem;
                        }
                    }

                    .des-item {
                        font-size: 0.26rem;
                        color: #4e4e4e;
                        padding-left: 0.33rem;
                        padding-top: 0.22rem;
                        margin-left: 0.2rem;
                        border-left: 0.02rem dashed #739bfe;
                        padding-bottom: 0.55rem;

                        .cdrcwewm {
                            width: 5.51rem;
                            height: 1.43rem;
                            margin-top: 0.16rem;
                        }
                    }

                    .describe-item {
                        font-size: 0.26rem;
                        color: #4e4e4e;
                        padding-left: 0.33rem;
                        padding-top: 0.22rem;
                        margin-left: 0.2rem;
                        word-break: break-all;
                    }
                }
            }
        }

        .sqsj {
            width: 6.85rem;
            height: 2.61rem;
            background: #ffffff;
            border-radius: 0.26rem 0.26rem 0.26rem 0.26rem;
            margin: 0.3rem auto 0;
            padding-top: 0.3rem;
            box-sizing: border-box;
            text-align: left;

            .rcgysq-sqsj {
                width: 5.58rem;
                height: 1.94rem;
                background-image: url("./../assets/imgs/xllh/rcgysq_sqsj.png");
                background-size: 100% 100%;
                background-repeat: no-repeat;
                margin: 0 auto;

                img {
                    height: 1.94rem;
                    width: 1.94rem;
                }
            }
        }

        .zrdw {
            font-size: 0.24rem;
            font-weight: 500;
            color: #97a9d9;
            margin-top: 0.16rem;
        }

        .phone-list {
            width: 6.85rem;
            background: #f9faff;
            border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
            margin: 0.36rem auto 0;
            font-size: 0.26rem;
            color: #4e4e4e;
            line-height: 0.26rem;
            padding-bottom: 0.5rem;

            .phone-list-title {
                width: 5.29rem;
                height: 1.14rem;
                margin-top: 0.42rem;
            }

            .content-list {
                margin: 0.3rem 0.3rem 0;

                .content-item {
                    display: flex;
                    border-bottom: 0.01rem solid #cbc8c8;

                    &:nth-last-child(1) {
                        border-bottom: none;
                    }

                    .area {
                        width: 2.2rem;
                        border-right: 0.01rem solid #cbc8c8;
                        padding: 0.15rem 0;

                        img {
                            width: 1.23rem;
                            height: 0.43rem;
                        }
                    }

                    .lxfs {
                        width: 4rem;
                        padding: 0.15rem 0;

                        img {
                            width: 2.73rem;
                            height: 0.43rem;
                        }
                    }
                }
            }
        }
    }
}
</style>
